module.exports = __webpack_public_path__ + "static/img/EQUIPTOP.ea7383c9.jpg";